import Vue from 'vue'
import PageContainer from './PageContainer'
import SearchRow from './SearchRow'
import ContainerCard from './ContainerCard'
import FieldLabel from './FieldLabel'
import FormButtons from './FormButtons'
import FieldDate from './FieldDate'
import FieldMoney from './FieldMoney'
import FieldView from './FieldView'
import ChangeCurrentCompany from './ChangeCurrentCompany'
import TemplateDefault from './TemplateDefault'
import Avatar from './Avatar'
import BackButton from './BackButton'
import Loading from './Loading'

Vue.component('PageContainer', PageContainer)
Vue.component('SearchRow', SearchRow)
Vue.component('ContainerCard', ContainerCard)
Vue.component('FieldLabel', FieldLabel)
Vue.component('FormButtons', FormButtons)
Vue.component('FieldDate', FieldDate)
Vue.component('FieldMoney', FieldMoney)
Vue.component('FieldView', FieldView)
Vue.component('ChangeCurrentCompany', ChangeCurrentCompany)
Vue.component('TemplateDefault', TemplateDefault)
Vue.component('Avatar', Avatar)
Vue.component('BackButton', BackButton)
Vue.component('Loading', Loading)
